import script from "./uploadOfIncomingMaterials.vue?vue&type=script&setup=true&lang=js"
export * from "./uploadOfIncomingMaterials.vue?vue&type=script&setup=true&lang=js"

import "./uploadOfIncomingMaterials.vue?vue&type=style&index=0&id=70c4e11f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70c4e11f"]])

export default __exports__